<section class="bg-white py-24">
  <div class="mx-auto grid max-w-page gap-16 px-4 sm:px-6 lg:grid-cols-[1.08fr_0.92fr] lg:px-8">
    <div class="grid gap-5">
      <div class="rounded-[2rem] bg-gradient-to-br from-primary-100 via-secondary-50 to-white p-6 shadow-xl shadow-slate-950/5">
        <div
          class="rounded-[1.5rem] border border-white/70 bg-white/90 p-5 shadow-xl shadow-primary-950/5 backdrop-blur">
          <div class="flex items-center justify-between">
            <div class="flex flex-col gap-1">
              <p class="text-body3 font-semibold text-primary-600">Form Builder</p>
              <h3 class="text-h6 text-slate-950">Customer Feedback Form</h3>
            </div>
            <span class="rounded-full bg-success-100 px-3 py-1 text-caption font-medium text-success-700">Published</span>
          </div>

          <div class="flex flex-col gap-4 py-6">
            <div class="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-white p-4">
              <p class="text-body3 font-medium text-slate-500">Question</p>
              <p class="text-body2 font-semibold text-slate-950">How was your experience?</p>
            </div>

            <div class="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4">
              <p class="text-body3 font-medium text-slate-500">Field Type</p>
              <div class="flex gap-2">
                <span class="rounded-full bg-primary-50 px-3 py-1 text-caption font-medium text-primary-700">Rating</span>
                <span class="rounded-full bg-slate-100 px-3 py-1 text-caption font-medium text-slate-600">Required</span>
              </div>
            </div>

            <div class="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-white p-4">
              <p class="text-body3 font-medium text-slate-500">Published Link</p>
              <p class="truncate text-body2 font-medium text-primary-600">formops.app/f/customer-feedback</p>
            </div>
          </div>
        </div>
      </div>

      <div class="grid gap-5 sm:grid-cols-2">
        <div class="relative flex flex-col gap-3 overflow-hidden rounded-[2rem] bg-primary-950 p-6 text-white shadow-xl shadow-slate-950/10">
          <div class="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-primary-500/30 blur-2xl"></div>
          <p class="text-body3 text-primary-200">Submissions</p>
          <h3 class="text-h6 text-white">1,248 responses collected</h3>
          <p class="text-body2 leading-6 text-primary-100">
            Track submitted data, response trends, completion status, and form performance.
          </p>
        </div>

        <div class="flex flex-col gap-6 rounded-[2rem] border border-slate-200 bg-slate-50 p-6 shadow-sm">
          <div class="flex items-center justify-between">
            <p class="text-body3 font-semibold text-secondary-600">AI Insight</p>
            <span class="rounded-full bg-secondary-100 px-3 py-1 text-caption font-medium text-secondary-700">New</span>
          </div>

          <div class="flex flex-col gap-3">
            <h3 class="text-h6 text-slate-950">Feedback trend detected</h3>
            <p class="text-body2 leading-6 text-slate-600">
              Most users mention faster onboarding and cleaner form experience.
            </p>
          </div>

          <div class="flex h-20 items-end gap-2">
            <div class="h-8 flex-1 rounded-t-lg bg-secondary-200"></div>
            <div class="h-11 flex-1 rounded-t-lg bg-secondary-300"></div>
            <div class="h-9 flex-1 rounded-t-lg bg-secondary-200"></div>
            <div class="h-14 flex-1 rounded-t-lg bg-secondary-400"></div>
            <div class="h-17 flex-1 rounded-t-lg bg-secondary-500"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-10">
      <div class="flex flex-col gap-4">
        <p class="text-caption font-semibold uppercase tracking-[0.2em] text-slate-500">
          From forms to intelligence
        </p>

        <h2 class="text-h2 font-medium text-slate-950">
          Create forms. Collect submissions. Understand data.
        </h2>
      </div>

      <p class="max-w-xl text-body1 leading-8 text-slate-600">
        FormOps helps teams build forms, publish form, collect structured submissions, and use AI insights
        to understand trends, patterns, and opportunities hidden inside submitted data.
      </p>

      <a
        href="#ai"
        class="inline-flex items-center gap-2 self-start rounded-full border border-primary-500 px-4 py-2 text-body2 font-semibold text-primary-600 hover:text-primary-700">
        Explore AI insights
        <app-svg-icon src="assets/icons/arrow-right-thin.svg" [size]="18"></app-svg-icon>
      </a>
    </div>
  </div>
</section>
